export default __webpack_public_path__ + "static/media/img3.849c573d.png";